<template>
  <div class="n-select" @mouseenter="handleEnter" @mouseleave="handleLeave">
    <div class="select-input__wrap" :class="{ selecting }">
      <input
        class="select-input"
        type="text"
        v-model="selected"
        :placeholder="placeholder"
        readonly="readonly"
      />
      <n-icon icon="icondown"></n-icon>
    </div>
    <ul class="select-list">
      <li
        class="select-item"
        v-for="(item, index) in options"
        :key="index"
        @click="handleSelected(item)"
      >
        <span>{{ item.label }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: "",
      selecting: false,
    };
  },
  mounted() {},
  methods: {
    handleShow() {
      this.selecting = !this.selecting;
    },
    handleLeave() {
      this.selecting = false;
    },
    handleEnter() {
      this.selecting = true;
    },
    handleSelected(item) {
      this.selected = item.value;
      this.selecting = false;
      this.$emit("select", this.selected);
    },
  },
  props: {
    options: {
      default: () => {
        return [];
      },
      type: Array,
    },
    placeholder: {
      default: "请选择",
      type: String,
    },
  },
};
</script>

<style lang="scss">
    .n-select {
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
    display: inline-block;
    width: 140px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    .select-input__wrap {
        position: relative;
        display: flex;
        padding: 4px 10px;
        .n-icon svg {
        transition: transform 0.4s ease;
        }
    }
    .select-input {
        font-size: 20px;
        min-width: 90px;
        cursor: pointer;
        background-color:transparent;
        color: #666666;    
    }
    .select-list {
        background: #ffffff;
        border-radius: 12px;
        overflow: hidden;
        margin-top: 6px;
        display: none;
        width: 100%;
        .select-item {
        padding: 12px 16px;
        width: 100%;
        border-radius: 12px;
        span {
            padding: 0 10px;
        }
        &:hover {
        background: #F4F4F4;
        }
        }
    }
    .selecting + .select-list {
        display: block;
    }
    .selecting .n-icon svg {
        transform: rotate(180deg);
        transition: transform 0.4s ease;
    }
    }
</style>